import React from 'react'
import {useItemVariant} from '.'
import {
    Heading,
    useMultiStyleConfig,
    Text
} from '@salesforce/retail-react-app/app/components/shared/ui'

const ItemName = () => {
    const styles = useMultiStyleConfig('ItemName')
    const variant = useItemVariant()

    return (
        <Heading as="h2" {...styles.heading}>
            <Text {...styles.headingLink}>{variant.productName || variant.name}</Text>
        </Heading>
    )
}

export default ItemName
